export enum AuthorizedCommunicationStatus {
  PENDENT = 'PENDENT',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED'
}

export enum AuthorizedCommunicationStatusTranslated {
  PENDENT = 'À Resolver',
  IN_PROGRESS = 'Em Andamento',
  RESOLVED = 'Resolvida'
}
